export const style = {
  container: {
    minHeight: "100vh",
  },
  logoContainer: {
    flexWrap: "nowrap",
  },
  logoImage: {
    width: 75,
    textAlign: "center",
  },
  loginFormContainer: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    rowGap: 6.3,
  },
  videoContainer: {
    display: {
      xs: "none",
      md: "flex",
    },
    position: "relative",
  },
};
